/**
 * Session-expiry handoff between the axios interceptor (src/index.js) and the
 * login page. The interceptor cannot show a toast itself — it redirects to the
 * login page straight away, which unmounts it — so it leaves this flag behind
 * and the login page shows the message once on mount.
 */
export const SESSION_EXPIRED_KEY = 'marq_session_expired';

export const SESSION_EXPIRED_MESSAGE = 'Your session expired. Please sign in again.';
